import { Button, Drawer, IDrawerProps } from '@blueprintjs/core'
import * as React from 'react'

export interface Props {
  drawerProps?: IDrawerProps
  header: string
  isOpen: boolean
  onClear: () => void
  onClose?: (event?: React.SyntheticEvent<HTMLElement, Event>) => void
}

const FilterDrawer: React.FC<Props> = ({ children, header, onClose, onClear, isOpen, drawerProps = {} }) => {
  return (
    <Drawer hasBackdrop={false} size={365} onClose={onClose} isOpen={isOpen} {...drawerProps} className="filter-drawer">
      <div className="bp3-drawer-header">
        <h3 className="bp3-heading">{header}</h3>
      </div>
      <div className="bp3-drawer-body">{children}</div>
      <div className="bp3-drawer-footer" style={{ display: 'flex' }}>
        <Button onClick={onClear}>Clear filters</Button>
        <Button style={{ marginLeft: '10px' }} onClick={onClose}>
          Close
        </Button>
      </div>
    </Drawer>
  )
}

export default FilterDrawer
